var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.52756 2.4984L25.6454 0.626658C25.8889 0.607827 26.1327 0.658252 26.3488 0.772112C26.5648 0.885971 26.7443 1.05862 26.8664 1.27012C26.9885 1.48163 27.0483 1.72336 27.0389 1.9674C27.0294 2.21144 26.9512 2.44783 26.8131 2.64929L13.1333 22.6C12.9931 22.8049 12.797 22.965 12.5683 23.0616C12.3397 23.1581 12.0881 23.1868 11.8436 23.1444C11.599 23.1019 11.3719 22.9901 11.1891 22.8222C11.0063 22.6543 10.8756 22.4374 10.8127 22.1974L8.70144 14.1741C8.67554 14.0757 8.67915 13.972 8.71182 13.8757C8.74449 13.7794 8.80478 13.6949 8.88517 13.6327L17.3248 7.10126C17.3599 7.07385 17.3873 7.03786 17.4045 6.99676C17.4216 6.95566 17.4278 6.91084 17.4226 6.86663L17.4061 6.8008C17.3842 6.74664 17.3447 6.70145 17.294 6.67257C17.2432 6.64369 17.1842 6.63282 17.1265 6.64172L17.0694 6.65675L7.20268 10.6957C7.10865 10.734 7.00545 10.7437 6.90592 10.7238C6.80638 10.7039 6.7149 10.6551 6.64284 10.5836L0.715996 4.70944C0.539592 4.53486 0.417086 4.31326 0.363068 4.07102C0.309051 3.82879 0.325798 3.57613 0.411316 3.34314C0.496834 3.11016 0.647518 2.90666 0.845421 2.75689C1.04332 2.60712 1.2801 2.5174 1.52756 2.4984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessageIcon);
export default __webpack_public_path__ + "static/media/send-message-icon.3776fdf39f21be49d4de5c835443526e.svg";
export { ForwardRef as ReactComponent };